module.exports = __webpack_public_path__ + "img/47.9.TU.385a221d.png";